/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_DescriptionInputs */

const en_admin_permissions_description = /** @type {(inputs: Admin_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage system permissions`)
};

const zh_admin_permissions_description = /** @type {(inputs: Admin_Permissions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理系统权限`)
};

/**
* | output |
* | --- |
* | "Manage system permissions" |
*
* @param {Admin_Permissions_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_permissions_description = /** @type {((inputs?: Admin_Permissions_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_permissions_description(inputs)
	return zh_admin_permissions_description(inputs)
});
export { admin_permissions_description as "admin.permissions.description" }